<div
    class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden mt-8 p-8">
<form [formGroup]="practiceForm">
    <div class="form-group">
        <div class="form-control">
            <label>Name der Praxis</label>
            <input matInput placeholder="Gemeinschaftspraxis XY" formControlName="name">
        </div>
    </div>
    <div class="form-group">
        <div class="form-control">
            <label>Straße</label>
            <input matInput placeholder="Hauptstraße" formControlName="street">
        </div>
        <div class="form-control">
            <label>Hausnummer</label>
            <input matInput placeholder="1" formControlName="houseNumber">
        </div>
        <div class="form-control">
            <label>PLZ</label>
            <input matInput placeholder="11111" formControlName="zipCode">
        </div>
        <div class="form-control">
            <label>Ort</label>
            <input matInput placeholder="Musterhausen" formControlName="city">
        </div>
    </div>
</form>
<div class="flex justify-between mt-4">
    <button class="btn secondary-button" (click)="cancel()">
        <span>Abbrechen</span>
    </button>
    <button class="btn primary-button" (click)="submit()">
        <span>Speichern</span>
    </button>
</div>
</div>
